<template>
  <div>
    <div class="p-ml-3 p-mb-0">
        <h1>{{isAdmin ? `${company.companyname} - `: ''}}Prosjekter</h1>
      </div>
    <projects />
  </div>
</template>

<script>
import projects from '@/components/projects/projects'

export default {
name: 'projectsPage',
components: {
  projects
},

computed: {
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  },
  company(){
    return this.$store.getters['companies/current']
  }
},
}
</script>